import { createTRPCReact, type CreateTRPCReact } from '@trpc/react-query';
import {
  AdminTrpcRouter,
  type ReactQueryOptions,
  type RouterInputs,
  type RouterOutputs,
} from '@duke-hq/svc-api/admin/web-api';

export const trpcAdmin: CreateTRPCReact<AdminTrpcRouter, unknown> =
  createTRPCReact<AdminTrpcRouter>();

export type AdminTrpcClient = typeof trpcAdmin;

export type { ReactQueryOptions, RouterInputs, RouterOutputs };
